import React from 'react';
import '../style/BlogArchive.css';
import { NavLink } from 'react-router-dom';
export default function BlogArchive  ()  {
  const posts = [
    {
      id: "post-6943",
      title: "What Is DevTestOps? Bridging Development, Testing, and Operations for Continuous Delivery",
      link: "#what-is-devtestops/",
      img: "#wp-content/uploads/2025/12/DevTestOpsTitle.jpeg",
      author: "Jonathan Steele",
      authorLink: "#author/jonathan-steele/",
      date: "December 12th, 2025",
      categories: [
        { name: "Software Testing", link: "#category/software-testing/" },
        { name: "Testing Types", link: "#category/testing-types/" }
      ],
      excerpt: "This is the era of rapid software delivery, and organizations are always under pressure to deliver faster, while maintaining or even improving quality. In this context, DevTestOps is increasingly gaining relevance as a means to combine development (Dev), testing (Test), and operations (Ops) into a single pipeline. At its core, DevTestOps aims to integrate quality [...]"
    },
    {
      id: "post-6941",
      title: "What is Test Scalability?",
      link: "#what-is-test-scalability/",
      img: "#wp-content/uploads/2025/12/ScalabilityTestingTitle.jpeg",
      author: "Jonathan Steele",
      authorLink: "#author/jonathan-steele/",
      date: "December 12th, 2025",
      categories: [
        { name: "Software Testing", link: "#category/software-testing/" },
        { name: "Testing Types", link: "#category/testing-types/" }
      ],
      excerpt: "Scalability is one of the most vital features of any software system, in today's world of constantly increasing user bases, data volumes, and cloud-driven architectures. It examines whether your program can adapt to a sudden increase or decrease in workload without impacting responsiveness or crashing. Test scalability, also known as scalability testing, is useful in [...]"
    },
    {
      id: "post-6897",
      title: "Functional Testing vs. Non-Functional Testing",
      link: "#functional-testing-vs-non-functional-testing/",
      img: "#wp-content/uploads/2025/10/Functional-Testing-vs.-Non-Functional-Testing-main_img.jpeg",
      author: "Elly Johnson",
      authorLink: "#author/marketing_ek1lhmaa/",
      date: "October 14th, 2025",
      categories: [{ name: "Testing Types", link: "#category/testing-types/" }],
      excerpt: "The core foundation of delivering high-quality applications is software testing. Testing ensures that your product works as intended and offers a smooth user experience. This is regardless of the size of the system that you are building, right from a small web application to a massive enterprise system. Functional testing and non-functional testing are the [...]"
    },
    {
      id: "post-6866",
      title: "What is Accessibility Testing?",
      link: "#what-is-accessibility-testing/",
      img: "#wp-content/uploads/2025/09/What-is-Accessibility-Testing-main_img.jpeg",
      author: "Elly Johnson",
      authorLink: "#author/marketing_ek1lhmaa/",
      date: "September 5th, 2025",
      categories: [{ name: "Testing Types", link: "#category/testing-types/" }],
      excerpt: "Inclusivity is of the highest importance in the current digital-first environment. Accessibility testing ensures that digital products, websites, and mobile apps can be utilized by people with a wide range of abilities, including those who have motor, auditory, cognitive, or visual impairments. Organizations that efficiently address these accessibility hurdles not only satisfy international standards but [...]"
    },
    {
      id: "post-6863",
      title: "What is Usability Testing?",
      link: "#what-is-usability-testing/",
      img: "#wp-content/uploads/2025/09/What-is-Usability-Testing-main_img.jpeg",
      author: "Elly Johnson",
      authorLink: "#author/marketing_ek1lhmaa/",
      date: "September 4th, 2025",
      categories: [{ name: "Testing Types", link: "#category/testing-types/" }],
      excerpt: "The concept of usability testing has become mandatory for building user-friendly experiences in the swiftly evolving space of digital goods, websites, and applications. In essence, usability testing entails monitoring actual real-time users with a product to detect issues, frustrations, and areas for improvement. Although it may seem simple, the information gained from usability studies often [...]"
    },
    {
      id: "post-6855",
      title: "What is Compatibility Testing?",
      link: "#what-is-compatibility-testing/",
      img: "#wp-content/uploads/2025/08/What-is-Compatibility-Testing-main_img.jpeg",
      author: "Elly Johnson",
      authorLink: "#author/marketing_ek1lhmaa/",
      date: "August 27th, 2025",
      categories: [{ name: "Testing Types", link: "#category/testing-types/" }],
      excerpt: "Today, in the fast-evolving digital landscape, software applications are accessed by users from myriad devices, operating systems, browsers, and networks. Obviously, it is important to make sure the app works fine in these various environments. Compatibility testing is essential in these cases. We need such non-functional testing, which examines whether an application can perform adequately [...]"
    },
    {
      id: "post-6852",
      title: "What is Vibe Testing?",
      link: "#what-is-vibe-testing/",
      img: "#wp-content/uploads/2025/08/What-is-Vibe-Testing-main_img.jpeg",
      author: "Elly Johnson",
      authorLink: "#author/marketing_ek1lhmaa/",
      date: "August 26th, 2025",
      categories: [{ name: "Testing Types", link: "#category/testing-types/" }],
      excerpt: "The safety measure that ensures applications' quality, dependability, and trust has always been software testing. Testing has always had to keep up with the delivery speed as development cycles are expedited due to agile methodologies and automation pipelines. A new idea called “vibe testing” has emerged with the development of artificial intelligence (AI), indicating a [...]"
    }
  ];

  return (
    <main id="main" className="blog-archive-guide">
      <div className="fusion-row">
        <section id="content" className="full-width" style={{ width: '100%' }}>
          <div id="posts-container" className="fusion-blog-archive fusion-blog-layout-medium-wrapper">
            <div className="fusion-posts-container fusion-blog-layout-medium">
              
              {posts.map((post) => (
                <article key={post.id} id={post.id} className="fusion-post-medium post fusion-clearfix">
                  
                  {/* Image/Slideshow Area */}
                  <div className="fusion-post-slideshow">
                    <div className="fusion-image-wrapper">
                      <img src={post.img} alt={post.title} className="wp-post-image" />
                      <div className="fusion-rollover">
                        <div className="fusion-rollover-content">
                          <a className="fusion-rollover-link" href={post.link}>{post.title}</a>
                          <div className="fusion-rollover-sep"></div>
                          <h4 className="fusion-rollover-title">{post.title}</h4>
                          <div className="fusion-rollover-categories">
                            {post.categories.map((cat, index) => (
                              <React.Fragment key={index}>
                                <a href={cat.link}>{cat.name}</a>
                                {index < post.categories.length - 1 && ', '}
                              </React.Fragment>
                            ))}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Content Area */}
                  <div className="fusion-post-content post-content">
                    <h2 className="entry-title fusion-post-title">
                      <a href={post.link}>{post.title}</a>
                    </h2>
                    <div className="fusion-post-content-container">
                      <p>{post.excerpt}</p>
                    </div>
                  </div>

                  <div className="fusion-clearfix"></div>

                  {/* Meta Info Area */}
                  <div className="fusion-meta-info">
                    <div className="fusion-alignleft">
                      By <span className="vcard"><a href={post.authorLink}>{post.author}</a></span>
                      <span className="fusion-inline-sep">|</span>
                      <span>{post.date}</span>
                      <span className="fusion-inline-sep">|</span>
                      {post.categories.map((cat, index) => (
                        <React.Fragment key={index}>
                          <a href={cat.link}>{cat.name}</a>
                          {index < post.categories.length - 1 && ', '}
                        </React.Fragment>
                      ))}
                      <span className="fusion-inline-sep">|</span>
                      <span className="fusion-comments">Comments Off</span>
                    </div>
                    <div className="fusion-alignright">
                      <a href={post.link} className="fusion-read-more">Read More</a>
                    </div>
                  </div>
                </article>
              ))}
 <div className="sharing-box">
          <h4>Share This Story, Choose Your Platform!</h4>
          <div className="fusion-social-networks">
    <NavLink to="https://facebook.com" target="_blank" rel="noreferrer" className="facebook">
      <i className="fab fa-facebook-f"></i>
    </NavLink>
    <NavLink to="https://twitter.com" target="_blank" rel="noreferrer" className="twitter">
      <i className="fab fa-twitter"></i>
    </NavLink>
    <NavLink to="https://www.linkedin.com/in/qa-coder-708418404/" target="_blank" rel="noreferrer" className="linkedin">
      <i className="fab fa-linkedin-in"></i>
    </NavLink>
    <NavLink to="https://wa.me/918299775823" target="_blank" rel="noreferrer" className="whatsapp">
      <i className="fab fa-whatsapp"></i>
    </NavLink>
    <NavLink to="mailto:qacoder0@gmail.com" className="email">
      <i className="fas fa-envelope"></i>
    </NavLink>
{/* Instagram */}
<NavLink to="https://www.instagram.com/qacoder0/?hl=en" target="_blank" rel="noreferrer" className="instagram">
  <i className="fab fa-instagram instagram-gradient"></i>
</NavLink>

{/* YouTube */}
<NavLink to="https://www.youtube.com/@QACoder" target="_blank" rel="noreferrer" className="youtube">
  <i className="fab fa-youtube"></i>
</NavLink>

{/* GitHub */}
<NavLink to="https://github.com/yourusername" target="_blank" rel="noreferrer" className="github">
  <i className="fab fa-github"></i>
</NavLink>

  </div>
        </div>
            </div>
          </div>
        </section>
      </div>
    </main>
  );
};

